<template>
    <div class="ml-20">
        <a-list item-layout="horizontal">
            <a-list-item>
                <a-list-item-meta>
                    <div slot="title">
                        <span class="mt-30 font-web mb-10" style="font-size: 18px;color: #610C9F !important;">
                            หากพบปัญหาในการใช้งาน Application
                        </span>
                    </div>
                    <div slot="description">
                        <span class="font-web" style="font-size: 14px;">ข้อมูลสำหรับติดต่อ</span>
                    </div>
                    <a-avatar :style="{ backgroundColor: '#610C9F' }" slot="avatar" shape="square" :size="55" icon="bug" />
                </a-list-item-meta>
            </a-list-item>
        </a-list>

        <a-descriptions class="mt-10 font-web" title="" bordered :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }">
            <a-descriptions-item style="color: black !important;" :span="5">
                <p class="mb-10" slot="label" style="font-size: 16px;color: black !important;">ช่องทางการแจ้งปัญหา / ฝากคำถาม</p>
                <a-button block class="mt-0 mb-5" @click="toIcService" type="primary">
                    <a-icon class="mr-2" type="form" />Service
                </a-button>
                <p class="mt-5 mb-0 font-web">1. เลือก Category : IC-APP </p>
                <p class="mt-5 mb-10 font-web">2. พร้อมตามด้วยปัญหาของท่าน</p>
            </a-descriptions-item>
            <a-descriptions-item style="color: black !important;" :span="5"
            >
            <p class="mb-10" slot="label" style="font-size: 14px;color: black !important;">ติดต่อสอบถามเจ้าหน้าที่</p>
                -
            </a-descriptions-item>
            <a-descriptions-item style="color: black !important;" :span="3">
                <p class="mb-10" slot="label" style="font-size: 14px;color: black !important;">สถานที่ ( หากต้องการแก้ปัญหา / หรือตรวจสอบอุปกรณ์ของท่าน )</p>
                -
            </a-descriptions-item>
        </a-descriptions>

        <div class="text-center">
            <p :style="{ fontSize: '14px' }" class="mt-20 mb-10 font-web font-weight-bold">Email
                &nbsp;&nbsp;<strong><a :style="{ fontSize: '14px' }"
                        href="mailto:ic-inhouse@mahidol.edu">ic-inhouse@mahidol.edu</a></strong> </p>
        </div>

    </div>
</template>

<script>
import MobileFrame from '../MobileFrame.vue';

export default {
    components: {
        MobileFrame,
    },
    data() {
        return {}
    },
    methods: {
        toIcService() {
            this.$router
                .push({
                    path: "/service/form",
                })
                .catch((err) => { });
        }
    }
}
</script>